import Component from '../component';

export default class Header extends Component {
    constructor(...args) {
        super(...args);

        this.params = {
            current: 0,
            next: 0,
            canClick: true
        }
    }

    init() {

        super.init();

        this.dom.images = this.dom.component.querySelectorAll(".content-image");

        if (this.dom.component.classList.contains('slider')) {
            this.dom.itemSlide = this.dom.component.querySelector(".item-slide");
            this.dom.containerText = this.dom.itemSlide.querySelector('.container-text');
            this.dom.contentText = this.dom.containerText.querySelectorAll('.content-text');
            this.dom.title = this.dom.containerText.querySelectorAll('.title-slide');
            this.dom.subtitle = this.dom.containerText.querySelectorAll('.subtitle-slide');
            this.dom.prev =  this.dom.component.querySelector('.prev');
            this.dom.next =  this.dom.component.querySelector('.next');
            this.dom.bullets = this.dom.component.querySelectorAll('.bullet');
            this.dom.button = this.dom.component.querySelectorAll('.content-button');

            this.params.total = this.dom.images.length - 1;
        }

    }
    bind() {

        super.bind();

        if (this.dom.images.length > 1){
            var height = this.dom.contentText[0].getBoundingClientRect().height;
            this.dom.containerText.style.height = height + "px";

            this.dom.prev.addEventListener("click", this._process.bind(this, "prev"));
            this.dom.next.addEventListener("click", this._process.bind(this, "next"));
        }

    }

    _process(direction){

        if ( this.params.canClick == false)
            return;

        this.params.canClick = false;
        if ( direction == "next" && this.params.current < this.params.total){
            this.params.next++;
        }
        else if (direction == "next" && this.params.current == this.params.total) {
            this.params.next = 0;
        }
        else if (direction == "prev" && this.params.current > 0) {
            this.params.next--;
        }
        else if (direction == "prev" && this.params.current == 0) {
            this.params.next = this.params.total;
        }

        this.anim= new TimelineMax({
            onComplete: () => {
                this.params.current = this.params.next;
                this.params.canClick = true;
            }
            // end
        });

        this._animate();
    }





    /*
    unbind() {
    }
    resize(width, height) {
    }
    */
}



// WEBPACK FOOTER //
// ./src/js/components/header/header.js